import React from 'react'
import { Body } from 'uiComponents/typography'
import { useTranslation } from 'translations'

const Disclaimer = () => {
    const { t } = useTranslation()
    return (
        <div style={{ marginBottom: '7em', maxWidth: 1200 }}>
            <Body size={2} color="light" weight="medium">
                {t('reports.disclaimer.title')}
            </Body>
            <Body size={3} color="light">
                {t('reports.disclaimer.text')}
            </Body>
        </div>
    )
}

export default Disclaimer
